import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { setPageTitle } from "../../../modules/application/pages";

import buttonConfig from "./button-config.js";

import PlayScreenCard from "./play-screen-card.js";

import NewsFeedTimocco from "./news-feed/news-feed-timocco.js";

// import SaintPatricksDayEasterEgg from "./easter-eggs/saint_patricks_day/saint-patricks-day-easter-egg.js";

//import ValentinesEasterEgg from "./easter-eggs/valentines/valentines-easter-egg.js";

// import HanukkahEasterEgg from "./easter-eggs/hanukkah/hanukkah-easter-egg.js";

// import TurkeyEasterEgg from "./easter-eggs/thanksgiving/turkey-easter-egg"

import "./play-screen-timocco.css";
import { withWhiteLabelContext } from "react-whitelabel";

class PlayScreenTimocco extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canClickTree: true,
      showingSanta: false,
    };

    this.props.dispatch(setPageTitle(""));
  }

  render() {
    const { token, currentUser, label } = this.props;
    const content = label.playScreen;

    let limitedUser = currentUser.limited;
    return (
      <div className="play_screen">
        <div className="timocco_play_screen_card_container">
          <div className="timocco_play_screen_title">{content.title}</div>
          {buttonConfig.map((cardData, index) => {
            let locked = false;
            if (limitedUser && !cardData.limited) {
              locked = true;
            }
            return (
              <PlayScreenCard
                card_data={cardData}
                token={token}
                locked={locked}
                key={index}
              ></PlayScreenCard>
            );
          })}
        </div>

        <NewsFeedTimocco token={token} />
        {/* <img title='Click Me... if you DARE!' alt='halloween_pumpkin' className={pumpkinClass} onClick={this.playHalloweenSound.bind(this)} src={require(`../../../static/assets/${pumpkinImageFilename}`)}></img> */}
        {/* <TurkeyEasterEgg />*/}
        {/* <ChristmasEasterEgg /> */}
        {/* <HanukkahEasterEgg /> */}
        {/* <ValentinesEasterEgg /> */}
        {/* <SaintPatricksDayEasterEgg /> */}
      </div>
    );
  }
}

const withState = connect((state) => {
  const {
    player,
    player_game_session,
    player_game_session_activity,
    result,
    skill,
    user,
  } = state;

  return {
    players: player.players,
    owned_players: player.owned_players,
    retrieved_assigned_players: player.retrieved_assigned_players,
    retrieved_players: player.retrieved_players,
    assigned_players: player.assigned_players,
    skills: skill.skills,
    results: result.results,
    token: user.token,
    currentUser: user,
    currentUserId: user.currentUserId,
    currentUserFirstName: user.currentUserFirstName,
    playerGameSessions: player_game_session.player_game_sessions,
    playerGameSessionActivities:
      player_game_session_activity.player_game_session_activities,
  };
});

export default withWhiteLabelContext(withRouter(withState(PlayScreenTimocco)));



// WEBPACK FOOTER //
// ./src/components/containers/play-screen/play-screen-timocco.js